// The only place YouTube hosts are trusted. Import-free: `sanitize-html` also runs on edge.

/** Hosts an `<iframe src>` may point at. TipTap passes an already-`/embed/` URL through untouched. */
const YOUTUBE_EMBED_HOSTS = [
	'youtube.com',
	'www.youtube.com',
	'm.youtube.com',
	'youtube-nocookie.com',
	'www.youtube-nocookie.com',
];

/** Share links resolve to a video but never serve `/embed/`, so they are accepted as input only. */
const YOUTUBE_SHARE_HOSTS = ['youtu.be', 'www.youtu.be'];

/** Exact hostname match — `endsWith` would let `evil-youtube.com` through. */
const hasHost = (url: string, hosts: string[]): boolean => {
	try {
		const { protocol, hostname } = new URL(url);
		if (protocol !== 'https:' && protocol !== 'http:') return false;
		return hosts.includes(hostname.toLowerCase());
	} catch {
		return false;
	}
};

/** True for a link a user may paste into the embed prompt. */
export const isYoutubeUrl = (url: string): boolean =>
	hasHost(url, [...YOUTUBE_EMBED_HOSTS, ...YOUTUBE_SHARE_HOSTS]);

/** True for a URL allowed to survive sanitization as an `<iframe src>`. */
export const isYoutubeEmbedUrl = (url: string): boolean => hasHost(url, YOUTUBE_EMBED_HOSTS);
